module.exports = __webpack_public_path__ + "img/symbol-one-seventh-center.19f6a79e.png";